'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _NavApp = require('../pages/NavApp');

var _NavApp2 = _interopRequireDefault(_NavApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BadLink = function BadLink() {
  return _react2.default.createElement(
    _NavApp2.default,
    null,
    _react2.default.createElement(
      'div',
      { className: 'dummy-page bad-link' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'title' },
          'Bad Link'
        ),
        _react2.default.createElement(
          'div',
          { className: 'reason' },
          'If you\'ve expected to arrive at your profile, perhaps you\'ve opted-in using a different email address than the one you were using on inbound.org? Simply login to HubSpot with that email address and click the opt-in link again.'
        ),
        _react2.default.createElement(
          'div',
          { className: 'reason' },
          'If you\'ve expected to arrive at someone else\'s profile, that user maybe have unpublished their page'
        )
      )
    )
  );
};

exports.default = BadLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/pages/BadLink.js
// module id = 361
// module chunks = 0